// @givmo/app-charity — Board's one line for the lock notice (AS-WEB27's rider), carried from the
// director ways-in card to the director's email forms (cut 1007e's fold, Board's B-F2).
//
// Board gives the line to the ways-in card only, and only from an invitation (frame a0). A director
// who picks "Continue with email" goes on to the console's email forms, a separate route, where the
// lock can refuse them too; the line goes with them. Held in memory, not with the invitation's two
// facts in storage (`director-invitation-handoff.ts`): it is a rendered node, not data. A reload
// loses it, and the invitation landing hands it over again.
//
// The card writes it each time the person picks email: the line from an invitation, nothing from
// the door or Board's "use another Givmo account" steps, so a line never outlives the arrival that
// gave it.

import type { ReactNode } from 'react';

let carried: ReactNode = undefined;

/** The ways-in card, on "Continue with email": the line its arrival gave, or nothing. */
export function carryDirectorLockNoticeLine(line: ReactNode): void {
  carried = line;
}

/** The director's email forms: the line to place in their lock notice, or nothing. */
export function carriedDirectorLockNoticeLine(): ReactNode {
  return carried;
}
